import { useEffect, useState } from 'react';
import { updateLimit, initImageRequest } from './ImageRequestService';

export const useLimit = ({ limit }) => {
  useEffect(() => {
    updateLimit(limit);
  }, [ limit ]);
}

export const useImageRequest = ({ url }) => {
  const [ src, setSrc ] = useState(undefined);
  const [ error, setError ] = useState(undefined);

  useEffect(() => {
    initImageRequest({ url })
      .then(setSrc)
      .catch(setError);
  }, [ url ]);

  return [ src, error ];
}
